module.exports = __webpack_public_path__ + "img/Like.9e6aaa62.svg";